import React from 'react';
import TranslationStore from '../../../stores/translations_store';
import getTranslatedText from '../../../helper/get_translated_text';
import {isEqual, forOwn} from '../../../../../lib/utilities';

/**
 * @attr translationKeys ->
 * @attr targetProperty ->
 * @attr placeholder (Optional) ->
 */
class MultiKeyContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = this._getState();
    }

    componentDidMount() {
        TranslationStore.addListener(() => {
            var newState = this._getState();
            if (!isEqual(newState, this.state)) {
                this.setState(newState);
            }
        });
    }

    render() {
        return React.cloneElement(this.props.children, {
            [this.props.targetProperty]: this.state.translationTexts
        });
    }

    _getState() {
        var translationTexts = {};

        forOwn(this.props.translationKeys, (translationKey, translationPlaceholder) => {
            if (this.props.transform && this.props.transform[translationPlaceholder]) {
                translationTexts[translationPlaceholder] = this.props.transform[translationPlaceholder](
                    getTranslatedText(translationKey, this.props.placeholder)
                );
            } else {
                translationTexts[translationPlaceholder] = getTranslatedText(translationKey, this.props.placeholder);
            }
        });

        return {translationTexts};
    }
}

export default MultiKeyContainer;